<template>
  <div class="screen page customers b-soft">
    <div class="grid">
      <section class="layout">
        <div class="container">
          <div class="row h-items-center">
            <GetCustomers />
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import GetCustomers from '@/components/customers.vue'
export default {
  name: 'app',
  components: {
    GetFooter,
    GetCustomers
  }
}
</script>